import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router'
import './BackLink.css'

const BackLink = props => {
  const { url, text, onClick } = props

  return (
    <div className='BackLink' onClick={onClick}>
      <svg width='7px' height='10px' viewBox='-1 -1 7 10'>
        <polygon
          stroke='none'
          fill='currentColor'
          fillRule='evenodd'
          transform='translate(2.500000, 4.500000) rotate(270.000000) translate(-2.500000, -4.500000)'
          points='2.5 2 7 7 -2 7' />
      </svg>
      <Link className='BackLink-link' to={url}>{text}</Link>
    </div>
  )
}

BackLink.defaultProps = {
  text: 'Back',
  onClick: false
}

BackLink.propTypes = {
  url: PropTypes.string,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.oneOfType([ PropTypes.func, PropTypes.bool ]).isRequired
}

BackLink.displayName = 'BackLink'

export default BackLink



// WEBPACK FOOTER //
// ./ui/BackLink.js